/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseGifAnimation,
    PressReleaseGifAnimationFromJSON,
    PressReleaseGifAnimationFromJSONTyped,
    PressReleaseGifAnimationToJSON,
} from './PressReleaseGifAnimation';
import {
    PressReleaseImage,
    PressReleaseImageFromJSON,
    PressReleaseImageFromJSONTyped,
    PressReleaseImageToJSON,
} from './PressReleaseImage';
import {
    PressReleaseLocation,
    PressReleaseLocationFromJSON,
    PressReleaseLocationFromJSONTyped,
    PressReleaseLocationToJSON,
} from './PressReleaseLocation';
import {
    ReleaseSendKbn,
    ReleaseSendKbnFromJSON,
    ReleaseSendKbnFromJSONTyped,
    ReleaseSendKbnToJSON,
} from './ReleaseSendKbn';
import {
    ReleaseSendTargetType,
    ReleaseSendTargetTypeFromJSON,
    ReleaseSendTargetTypeFromJSONTyped,
    ReleaseSendTargetTypeToJSON,
} from './ReleaseSendTargetType';

/**
 * プレスリリース編集データ
 * @export
 * @interface GetPressReleaseResponseData
 */
export interface GetPressReleaseResponseData {
    /**
     * リリースid
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    releaseId: number;
    /**
     * 企業id
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    companyId: number;
    /**
     * 
     * @type {ReleaseSendKbn}
     * @memberof GetPressReleaseResponseData
     */
    releaseSendKbn: ReleaseSendKbn;
    /**
     * エディタのバージョン @see https://www.notion.so/fea20dce98c94dc792d9d0e965ca50b0
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    editorVersion?: string | null;
    /**
     * リリース完了フラグ
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    compleFlg: boolean;
    /**
     * タイトル
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    title: string;
    /**
     * サブタイトル
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    subtitle: string | null;
    /**
     * リード文
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    head: string | null;
    /**
     * 本文
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    text: string;
    /**
     * 追加情報
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    footer: string | null;
    /**
     * 関連URL
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    referenceUrl: string | null;
    /**
     * メイン画像ファイル名
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    imageFileNameMain: string | null;
    /**
     * メイン画像ファイル名(s3)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    imageFileNameMainS3: string | null;
    /**
     * プレスリリース画像
     * @type {Array<PressReleaseImage>}
     * @memberof GetPressReleaseResponseData
     */
    images: Array<PressReleaseImage> | null;
    /**
     * プレスリリース画像
     * @type {Array<PressReleaseGifAnimation>}
     * @memberof GetPressReleaseResponseData
     */
    gifAnimations: Array<PressReleaseGifAnimation> | null;
    /**
     * プレスリリースファイル名(一般公開)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    releaseFileName: string | null;
    /**
     * 参考資料ファイル名(一般公開)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    referenceFileName: string | null;
    /**
     * プレスリリースファイル名(メディア限定)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    mediaReleaseFileName: string | null;
    /**
     * 参考資料ファイル名(メディア限定)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    mediaReferenceFileName: string | null;
    /**
     * 位置情報
     * @type {Array<PressReleaseLocation>}
     * @memberof GetPressReleaseResponseData
     */
    locations: Array<PressReleaseLocation>;
    /**
     * 記事ネタタグキーワード
     * @type {Array<string>}
     * @memberof GetPressReleaseResponseData
     */
    keywords: Array<string> | null;
    /**
     * リリース種類
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    releaseTypeId: string;
    /**
     * ビジネスカテゴリ
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    busiCateIdMain: number;
    /**
     * サブカテゴリ
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    busiCateIdSub: number | null;
    /**
     * 
     * @type {ReleaseSendTargetType}
     * @memberof GetPressReleaseResponseData
     */
    releaseSendTargetType: ReleaseSendTargetType;
    /**
     * メディアリストid
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    companyReleaseMediaJoinMasterId: number | null;
    /**
     * メディアリストid(インポート)
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    companyMMyReleaseMediaMasterId: number | null;
    /**
     * メディアリストへのメール配信を行う
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    releaseAdditionalHeadlineFlg: boolean;
    /**
     * メディアリストへのFAX配信を行う
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    releaseAdditionalFaxFlg: boolean;
    /**
     * FAX用ファイル名
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    releaseFaxFileName: string | null;
    /**
     * メールタイトルにprefix文字列を挿入する [~v3.0.0]
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    mailTitlePrefixFlg?: boolean;
    /**
     * メールタイトルprefix文字列 [~v3.0.0]
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    mailTitlePrefixText?: string | null;
    /**
     * メールタイトル先頭に企業名(略称)を追加する [^v3.0.0]
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    mailTitlePrefixCompanyNameFlg?: boolean;
    /**
     * メールタイトルを差し替える [^v3.0.0]
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    mailTitleReplacingFlg?: boolean;
    /**
     * メールタイトル [^v3.0.0]
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    mailTitle?: string | null;
    /**
     * メール本文の先頭に指定した文字列を挿入する
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    mailBodyHeadFlg: boolean;
    /**
     * メール本文先頭に挿入する文字列
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    mailBodyHeadText: string | null;
    /**
     * メディアユーザーへ配信する
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    mediaUserSendmailFlg: boolean;
    /**
     * 個人ユーザーへ配信する
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    socialmediaUserSendmailFlg: boolean;
    /**
     * 提携メディアへの転載
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    otherSiteSendFlg: boolean;
    /**
     * メディア限定公開
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    releaseMediaUserOnlyFlg: boolean;
    /**
     * PR TIMESのサイトに公開しない
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    releaseMediaListOnlyFlg: boolean;
    /**
     * 指定したメディアリストにのみ素材ダウンロードを表示する
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    isFileDownloadUnavailable: boolean;
    /**
     * 予約配信日(yyyy-mm-dd)
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    releaseDate: string | null;
    /**
     * 予約配信時間(hhmm) e.g. '0000', '0900', '2300'
     * @type {string}
     * @memberof GetPressReleaseResponseData
     */
    releaseTimeKbn2: string | null;
    /**
     * twitter投稿
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    twitterSendFlg: boolean;
    /**
     * facebook投稿
     * @type {boolean}
     * @memberof GetPressReleaseResponseData
     */
    facebookSendFlg: boolean;
    /**
     * プレスリリースの目的ID
     * @type {number}
     * @memberof GetPressReleaseResponseData
     */
    purposeId?: number | null;
}

export function GetPressReleaseResponseDataFromJSON(json: any): GetPressReleaseResponseData {
    return GetPressReleaseResponseDataFromJSONTyped(json, false);
}

export function GetPressReleaseResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'companyId': json['company_id'],
        'releaseSendKbn': ReleaseSendKbnFromJSON(json['release_send_kbn']),
        'editorVersion': !exists(json, 'editor_version') ? undefined : json['editor_version'],
        'compleFlg': json['comple_flg'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'head': json['head'],
        'text': json['text'],
        'footer': json['footer'],
        'referenceUrl': json['reference_url'],
        'imageFileNameMain': json['image_file_name_main'],
        'imageFileNameMainS3': json['image_file_name_main_s3'],
        'images': (json['images'] === null ? null : (json['images'] as Array<any>).map(PressReleaseImageFromJSON)),
        'gifAnimations': (json['gif_animations'] === null ? null : (json['gif_animations'] as Array<any>).map(PressReleaseGifAnimationFromJSON)),
        'releaseFileName': json['release_file_name'],
        'referenceFileName': json['reference_file_name'],
        'mediaReleaseFileName': json['media_release_file_name'],
        'mediaReferenceFileName': json['media_reference_file_name'],
        'locations': ((json['locations'] as Array<any>).map(PressReleaseLocationFromJSON)),
        'keywords': json['keywords'],
        'releaseTypeId': json['release_type_id'],
        'busiCateIdMain': json['busi_cate_id_main'],
        'busiCateIdSub': json['busi_cate_id_sub'],
        'releaseSendTargetType': ReleaseSendTargetTypeFromJSON(json['release_send_target_type']),
        'companyReleaseMediaJoinMasterId': json['company_release_media_join_master_id'],
        'companyMMyReleaseMediaMasterId': json['company_m_my_release_media_master_id'],
        'releaseAdditionalHeadlineFlg': json['release_additional_headline_flg'],
        'releaseAdditionalFaxFlg': json['release_additional_fax_flg'],
        'releaseFaxFileName': json['release_fax_file_name'],
        'mailTitlePrefixFlg': !exists(json, 'mail_title_prefix_flg') ? undefined : json['mail_title_prefix_flg'],
        'mailTitlePrefixText': !exists(json, 'mail_title_prefix_text') ? undefined : json['mail_title_prefix_text'],
        'mailTitlePrefixCompanyNameFlg': !exists(json, 'mail_title_prefix_company_name_flg') ? undefined : json['mail_title_prefix_company_name_flg'],
        'mailTitleReplacingFlg': !exists(json, 'mail_title_replacing_flg') ? undefined : json['mail_title_replacing_flg'],
        'mailTitle': !exists(json, 'mail_title') ? undefined : json['mail_title'],
        'mailBodyHeadFlg': json['mail_body_head_flg'],
        'mailBodyHeadText': json['mail_body_head_text'],
        'mediaUserSendmailFlg': json['media_user_sendmail_flg'],
        'socialmediaUserSendmailFlg': json['socialmedia_user_sendmail_flg'],
        'otherSiteSendFlg': json['other_site_send_flg'],
        'releaseMediaUserOnlyFlg': json['release_media_user_only_flg'],
        'releaseMediaListOnlyFlg': json['release_media_list_only_flg'],
        'isFileDownloadUnavailable': json['is_file_download_unavailable'],
        'releaseDate': json['release_date'],
        'releaseTimeKbn2': json['release_time_kbn_2'],
        'twitterSendFlg': json['twitter_send_flg'],
        'facebookSendFlg': json['facebook_send_flg'],
        'purposeId': !exists(json, 'purpose_id') ? undefined : json['purpose_id'],
    };
}

export function GetPressReleaseResponseDataToJSON(value?: GetPressReleaseResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'company_id': value.companyId,
        'release_send_kbn': ReleaseSendKbnToJSON(value.releaseSendKbn),
        'editor_version': value.editorVersion,
        'comple_flg': value.compleFlg,
        'title': value.title,
        'subtitle': value.subtitle,
        'head': value.head,
        'text': value.text,
        'footer': value.footer,
        'reference_url': value.referenceUrl,
        'image_file_name_main': value.imageFileNameMain,
        'image_file_name_main_s3': value.imageFileNameMainS3,
        'images': (value.images === null ? null : (value.images as Array<any>).map(PressReleaseImageToJSON)),
        'gif_animations': (value.gifAnimations === null ? null : (value.gifAnimations as Array<any>).map(PressReleaseGifAnimationToJSON)),
        'release_file_name': value.releaseFileName,
        'reference_file_name': value.referenceFileName,
        'media_release_file_name': value.mediaReleaseFileName,
        'media_reference_file_name': value.mediaReferenceFileName,
        'locations': ((value.locations as Array<any>).map(PressReleaseLocationToJSON)),
        'keywords': value.keywords,
        'release_type_id': value.releaseTypeId,
        'busi_cate_id_main': value.busiCateIdMain,
        'busi_cate_id_sub': value.busiCateIdSub,
        'release_send_target_type': ReleaseSendTargetTypeToJSON(value.releaseSendTargetType),
        'company_release_media_join_master_id': value.companyReleaseMediaJoinMasterId,
        'company_m_my_release_media_master_id': value.companyMMyReleaseMediaMasterId,
        'release_additional_headline_flg': value.releaseAdditionalHeadlineFlg,
        'release_additional_fax_flg': value.releaseAdditionalFaxFlg,
        'release_fax_file_name': value.releaseFaxFileName,
        'mail_title_prefix_flg': value.mailTitlePrefixFlg,
        'mail_title_prefix_text': value.mailTitlePrefixText,
        'mail_title_prefix_company_name_flg': value.mailTitlePrefixCompanyNameFlg,
        'mail_title_replacing_flg': value.mailTitleReplacingFlg,
        'mail_title': value.mailTitle,
        'mail_body_head_flg': value.mailBodyHeadFlg,
        'mail_body_head_text': value.mailBodyHeadText,
        'media_user_sendmail_flg': value.mediaUserSendmailFlg,
        'socialmedia_user_sendmail_flg': value.socialmediaUserSendmailFlg,
        'other_site_send_flg': value.otherSiteSendFlg,
        'release_media_user_only_flg': value.releaseMediaUserOnlyFlg,
        'release_media_list_only_flg': value.releaseMediaListOnlyFlg,
        'is_file_download_unavailable': value.isFileDownloadUnavailable,
        'release_date': value.releaseDate,
        'release_time_kbn_2': value.releaseTimeKbn2,
        'twitter_send_flg': value.twitterSendFlg,
        'facebook_send_flg': value.facebookSendFlg,
        'purpose_id': value.purposeId,
    };
}

